import { messageSW, Workbox } from "workbox-window";
import { CSRF_TOKEN_EVENT_TYPE, SYNC_EVENT_TYPE } from "../../constants.js";
import { del, set } from "../../utils/idb.js";
import { logAndCaptureError } from "../../utils/log.js";
import { getOrPresentMessage } from "../global-controllers/messages/utils.js";
import { getCsrfToken } from "./csrf.js";
import { gettext } from "./i18n.js";
export const registerSWAndSendInitialMessages = async () => {
    try {
        if (window._APP_.sentry) {
            await set("keyval", window._APP_.sentry, "sentry");
        }
        else {
            await del("keyval", "sentry");
        }
    }
    catch (error) {
        logAndCaptureError(error, { message: "Setting Sentry" });
        getOrPresentMessage("error", gettext("Background sync is not working. Try reloading the page."));
    }
    try {
        const wb = new Workbox("/serviceworker.js", { type: "module" });
        await wb.register();
    }
    catch (error) {
        logAndCaptureError(error, { message: "Registering SW" });
        getOrPresentMessage("error", gettext("Background sync is not working. Try reloading the page."));
    }
    if (navigator.serviceWorker.controller) {
        sendInitialMessagesWhenActivated(navigator.serviceWorker.controller);
    }
    navigator.serviceWorker.oncontrollerchange = (event) => {
        // The controller sometimes is missing here for some reason.
        const { controller } = event.target;
        if (controller) {
            sendInitialMessagesWhenActivated(controller);
        }
    };
};
export const sendInitialMessagesWhenActivated = (controller) => {
    if (controller.state === "activated") {
        sendInitialMessages();
    }
    else {
        controller.onstatechange = (event) => {
            if (event.target.state === "activated") {
                sendInitialMessages();
            }
        };
    }
};
const sendInitialMessages = async () => {
    if (navigator.serviceWorker.controller) {
        const csrfToken = getCsrfToken();
        await messageSW(navigator.serviceWorker.controller, {
            type: CSRF_TOKEN_EVENT_TYPE,
            payload: {
                csrfToken,
                translations: {
                    "Could not upload": gettext("Could not upload"),
                },
            },
        });
        messageSW(navigator.serviceWorker.controller, {
            type: SYNC_EVENT_TYPE,
        });
    }
};
//# sourceMappingURL=sw.js.map